module.exports = __webpack_public_path__ + "static/img/风道人员记录.f9795b01.png";